import {Space, Typography} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import ControlsService from "../../../services/ControlsService";
import {observer} from "mobx-react";
import {useEffect} from "react";
import "./style.scss";
//store
import Store from "../../../stores";
import UserService from "../../../services/UserService";

export default observer(function Politics() {
    const {t} = useTranslation();
    const chatOpened = ControlsService.chatOpened;

    const SetChartra = async () => {
        // WidgetChartra(document, window, "Chatra", Store.user, true);
    };

    useEffect(() => {
        SetChartra();
        UserService.getDocs();
    }, []);


    useEffect(() => {
        // const chatra = (window as any).Chatra;
        // if (typeof chatra !== "function") {
        //     return;
        // }
        // if (chatOpened) {
        //     chatra("show");
        //     chatra("openChat", true);
        // } else {
        //     chatra("hide");
        // }
    }, [chatOpened]);

    return (
        <Typography as="div" className="bl-politics">
            <Space size={8} direction="vertical" align="center">
                <Typography size={12} color="rgba(255, 255, 255, 0.5)">
                    {t("При входе вы принимаете:")}
                </Typography>
                {Store.user.docs?.map((i: {url: string; title: string}, k: number) => (
                    <a href={i.url} target="_blank" key={k}>
                        <Typography size={12} underline color="#fff">
                            {i.title}
                        </Typography>
                    </a>
                ))}
                {/* <Typography
                    size={12}
                    className="bl-politics-support"
                    underline
                    color="#fff"
                    onClick={onClick}
                >
                    {t("Поддержка")}
                </Typography> */}
            </Space>
        </Typography>
    );
});
